import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Browsers.es.js";
const r = o.forwardRef((e, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...e, weights: a }));
r.displayName = "BrowsersIcon";
const n = r;
export {
  n as Browsers,
  r as BrowsersIcon
};
